import { client, unwrap } from './client';

export interface UsageTotals {
  totalRequests: number;
  totalTokens: number;
  totalPriceMicrocents: number;
}
export interface UsageByDay {
  date: string;
  requests: number;
  tokens: number;
  priceMicrocents: number;
}
export interface UsageByModel {
  _id: string;
  requests: number;
  tokens: number;
}
export interface UsageByEndpoint {
  _id: string;
  requests: number;
  tokens: number;
}

export interface UsageResponse {
  period: string;
  totals: UsageTotals;
  byDay: UsageByDay[];
  byModel: UsageByModel[];
  byEndpoint: UsageByEndpoint[];
}

export const getUsage = (days = 30): Promise<UsageResponse> =>
  unwrap(client.get(`/inference-customer/usage?days=${days}`));
